import { render, staticRenderFns } from "./SupplierDetail.vue?vue&type=template&id=1e5d492d&scoped=true"
import script from "./SupplierDetail.vue?vue&type=script&lang=js"
export * from "./SupplierDetail.vue?vue&type=script&lang=js"
import style0 from "./SupplierDetail.vue?vue&type=style&index=0&id=1e5d492d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5d492d",
  null
  
)

export default component.exports